import {theme} from "./theme";
import AuthBg from '../../files/img/bg/bg.png'
import VendorBg from '../../files/img/bg/vendor-bg.png'
import ContactBg from '../../files/img/bg/contact.jpg'

const drawerWidth = 220;
export const  Styles = {

    paperLoginPage: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding:theme.spacing(3),
    },

    textRight:{
        textAlign:'right',
    },
    textLeft:{
        textAlign:'left',
    },
    inputCtl:{
    },
    textFloat:{
        textAlign:'left',
    },

    requiredSign:{
        color:theme.palette.secondary.main,
    },
    form: {
        width: '100%',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    mr10:{
        marginRight:10,
    },
    me10:{
        marginRight:10,
    },
    ml10:{
      marginLeft:10
    },
    my10:{
      marginLeft:10,
      marginRight:10
    },
    modalCloseButton:{
        position:"absolute !important",
        right:15,
        top:15
    },
    root: {
        display: 'flex',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        overflow:'hidden',
        minHeight:"100vh",
    },
    dialogRoot:{

    },
    mainContent: {
        flex: 1,
        display: 'flex',
    },
    WelcomRroot:{
        display: 'flex',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    toolbar: {
        paddingLeft: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        color: "#fff",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    colorWhite:{
        color:"rgba(255, 255, 255, 0.9)",
        width: "0.9em !important",
        height: "0.9em !important",
    },
    titleIcon: {
        float:"right"
    },
    appBar: {
        backgroundColor:"#2b2b2b",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        "& .MuiBottomNavigationAction":{
            maxWidth:160,
            minWidth:60,
            padding:0,
        },
    },
    appBarShift: {
        backgroundColor:"#2b2b2b",
    },
    appbar:{
        borderBottomLeftRadius:30,
        borderBottomRightRadius:30,
        borderTopColor:theme.palette.primary.main,
        borderTopWidth:3,
        boxShadow:"0 2px 15px rgba(0,0,0,0.15) !important",
        borderTopStyle:"solid",
        [theme.breakpoints.down('md')]: {
            borderBottomLeftRadius:0,
            borderBottomRightRadius:0,
        },
    },
    appToolbar:{
        display:"flex",
        alignItems:"center",
        justifyContent:'space-between',

    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        backgroundColor: "#2b2b2b",
        color: "#fff",
        position: 'fixed',
        whiteSpace: 'nowrap',
        overflowX:"hidden",
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(0),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(8),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        overflow: 'auto',
        width:"100vw",
        [theme.breakpoints.up('lg')]: {
            width: "77vw",
            overflowX:"hidden"
        },
    },
    rootContainer:{
        display:"flex",
        justifyContent:"center",
        [theme.breakpoints.up('lg')]: {
            marginLeft:'4vw',
        },
    },
    rootContainerPanel:{
        display:"flex",
        justifyContent:"center",
        [theme.breakpoints.up('lg')]: {
            marginLeft:'16rem',
            width:"calc(100vw - 16rem)"
        },
    },
    container: {
        paddingTop: theme.spacing(3),
        marginTop:45,
        [theme.breakpoints.up('lg')]: {
            paddingLeft:"0 !important",
            paddingRight:"0 !important",
            marginTop:33,
        },
    },

    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        borderRadius:10,
        overflow: 'auto',
        flexDirection: 'column',
        boxShadow:"0px 0px 10px rgba(82, 82, 82, 0.21)",
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom:  theme.spacing(1)
    },
    SidebarPaper:{
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        marginBottom:  theme.spacing(1)
    },
    uploadProgress:{
        '& span.success': {
            color: "#4caf50"
        },
    },
    fixedHeight: {
        height: 240,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    DrawerRoot: {
        width: '100%',
        maxWidth: drawerWidth,

    },
    activeItem: {
        color: "#ffffff",
        backgroundColor: "#4c4c4c",
        borderLeft:"5px solid " + theme.palette.primary.light ,
        display:"block",
        textDecoration: "none"
    },
    activeItemDropDown:{
        color: "#ffffff",
        backgroundColor: "#4c4c4c",
        borderLeft:"5px solid " + theme.palette.primary.light ,

    },
    listItemText: {
        textDecoration: "none"
    },
    Tabroot: {
        flexGrow: 1,
        maxWidth: 370,
        overflow:"hidden",
        padding:" 0 10px",
        borderTop:"3px solid #F0051F",
        [theme.breakpoints.down('md')]: {
            maxWidth: 330,
        },
    },
    tabHeader: {
        backgroundColor:theme.palette.background.default,
        '& .Mui-selected': {
            color: theme.palette.primary.main
        },
    },
    ProfileDrawer: {
        backgroundColor: "#424242",
        color: "#fff",
        width: "21rem",
        zIndex: 3000000,
        borderRadius: theme.direction === "rtl" ?  "0 30px 30px 0" : "30px 0 0 30px",
        [theme.breakpoints.down("md")]: {
            width: "19rem",
        },
    },
    emptyNotification:{
        border:"1px solid #ddd",
        textAlign:"center",
        padding:10,
        borderRadius:8,
        marginTop:"10px !important"
    },
    DataTable: {
        backgroundColor:'#ffffff',
        display:"none"
    },
    addButton: {
        textDecoration: "none",
    },

    appBarDialog: {
        position: 'relative',
        backgroundColor:theme.palette.background.paper,
    },
    titleDialog: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    FileManagerInput: {
        display:"none"
    },
    ButtonProgress: {
        fontSize:20
    },
    dialogClose:{
        position:"absolute !important",
        top:10,
        left: theme.direction === "rtl" ?  15 : "unset",
        right: theme.direction === "rtl" ?  "unset" : 15,
    },
    drawerClose:{
        position:"absolute !important",
        top:0,
        right:0
    },
    FMThumbnail: {
        width:50,
        borderRadius: '10%',
    },
    avatar: {
        width:50,
        borderRadius: '100%',
    },
    sticky: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        position:"sticky",
        top: 100,
    },
    galleryRoot: {
        maxWidth: 150,
        margin:10,
        display:"inline"
    },
    litleUrlShower:{
        fontSize: 11,
        color:theme.palette.primary.light,
        fontWeight:700,
        cursor: "pointer",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
    },
    Stepperroot: {
        width: '100%',
        backgroundColor:"#fff",
        padding: theme.spacing(2),
    },
    Stepperbutton: {
        marginRight: theme.spacing(1),
    },
    backStepperbutton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    StepperInstructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    messagesScreenRoot: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    appsContentContainer:{
        display: 'flex',
        flexDirection: 'column',
        overflow:"auto",
        height: `calc(100% - 115px)`,
        [theme.breakpoints.up('sm')]: {
            height: `calc(100% - 60px)`,
        },
        [theme.breakpoints.up('xl')]: {
            height: `calc(100% - 77px)`,
        },
    },
    emojiOpener:{
        position: "absolute",
        bottom: 5,
        right: 5
    },
    messageItemRoot: {
        marginBottom: 22,
        '&:last-child': {
            marginBottom: 0,
        },
        '&.right $messageChatRoot': {
            '& .message-time': {
                marginLeft: 0,
                marginRight: 55,
                textAlign: 'right',
            },
        },
        '&.right $messageChat': {
            flexDirection: 'row-reverse',
            backgroundColor:"#2DCEB3",
            color: theme.palette.background.default,
            '& .MuiAvatar-root': {
                marginRight: -65,
                marginLeft: 0,
            },
            '& .message-info': {
                marginLeft: 0,
                display: 'flex',
                alignItems: 'center',
            },
        },
    },
    messageChatRoot: {
        position: 'relative',
    },
    messageTime: {
        fontSize: 12,
        marginLeft: 55,
        marginBottom: -15,
        color: theme.palette.grey[500],
        display: 'block',
    },
    messageChat: {
        display: 'flex',
        borderRadius: 4,
        padding: '5px 15px',
        position: 'relative',
        marginLeft: 35,
        marginRight: 35,
        marginTop: 20,
        marginBottom: 10,
        maxWidth:650,
        minWidth:100,
        backgroundColor: "#f6f6f6",
        '& .MuiAvatar-root': {
            marginLeft: -65,
            marginTop: -5,
        },
        '& .message-info': {
            fontSize: 14,
            minWidth:300,
            marginTop:10,
            paddingRight:20,
            paddingLeft:20,
            marginBottom:10,
            [theme.breakpoints.up('lg')]: {
                fontSize: 16,
            },
        },
    },
    textPointer: {
        cursor: 'pointer',
    },
    GridAsaPaper:{
        backgroundColor: "#fff",
        borderRadius: 10,
        marginTop:15,
        boxShadow:"0px 0px 10px rgba(82, 82, 82, 0.21)",
        padding: 10
    },
    GridAsaPaperTransParent:{
        padding: 10
    },
    MenuItemDef: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    BreadLink: {
        display: 'flex',
        color:theme.palette.text.primary,
        textDecoration:"none",
        fontSize:13,
    },
    BreadIcon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    breadCrumb: {
        marginTop: "0 !important",
        marginLeft: "0 !important",
        [theme.breakpoints.down('sm')]: {
            fontSize:'13px',
            marginTop: "5px !important",
        },
    },
    LoadingButtonWrapper: {
        position: 'relative',
        margin: theme.spacing(2,0),
        textAlign:'center'
    },

    buttonProgress: {
        color: "#ff9f00",
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    LoadingButtonRoot: {
        display: 'flex',
        alignItems: 'center',
    },
    ListRootWithoutHeight: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        overflowY:"auto",
        height: '100%',
        maxHeight: 300,
        marginBottom: 10,
    },
    ListRootWithHeight: {
        minHeight:300
    },
    link:{
        color: theme.palette.primary.main,
        '&:hover': {
            textDecoration:"none",
        },
    },
    linkSecondary:{
        '&:hover': {
            textDecoration:"none",
        },
    },
    loginPageLogo:{
        maxHeight:70,
        margin:15
    },
    loginPageContainer:{
        height:"100vh",
        backgroundColor:"#f7f7f7"
    },
    LoginFormGrid:{
        borderRadius:10,
        backgroundColor:'#ffffff',
        padding:"30px !important"
    },
    image: {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    mainLogo:{
        maxHeight:50,
        paddingRight:10
    },
    NotificationsHolder:{
        padding:10,
        height:'88%',
        overflow:"auto",
    },
    NotificationAlert: {
        marginTop:10,
        "& .notification-time":{
            fontSize:"12px !important",
        },
        "& .MuiAlert-message":{
            width:"100%",
        },
    },

    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    large: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
    ListItemWidth:{
        minWidth: "30px !important"
    },
    activeProfileItem:{
        color: "#2b2b2b",
        fontSize: "10px !important",
        backgroundColor:"#f9f9f9",
        borderLeft:"5px solid " + theme.palette.primary.light ,
        '&:hover': {
            color: theme.palette.text.primary,
        }
    },
    CartBox:{
        paddingTop:"18px !important"
    },
    CartBoxWithoutPadding: {
        backgroundColor: "#f9f9f9",
        borderRadius:4,
        paddingTop:"0 !important",
        marginTop:'10px !important',
    },
    Step:{
        cursor:"pointer",
    },
    filterContainer:{
        backgroundColor:"#f6f6f6",
        padding:15,
        borderRadius:4,
        position:'relative',
        marginBottom:20,
    },
    primaryLink:{
        color:theme.palette.primary.main
    },
    ProviderManagerRoot: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    dashboardTitle : {
        borderBottom: "1px solid #bbb",
        paddingTop:15,
        paddingBottom:5,
        fontWeight: 700 ,
        display: "block",
        fontSize:20
    },
    ListRoot: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        overflowY:"auto",
        height: '100%',
        maxHeight: 450,
        marginBottom: 10
    },
    PassVisibilityIcon: {
        position: "absolute !important",
        right: 10,
        top: "50%",
        transform: "translateY(-50%)"
    },
    GridAsaPaperBaby:{
        borderRadius: 5,
        paddingBottom:10,
        paddingTop:20,
        backgroundColor: "rgba(87, 215, 194, .7)"
    },
    GridAsaPaperLive:{
        backgroundColor: "#fff",
        borderRadius: 7,
        paddingBottom:15,
        boxShadow:"0px 0px 3px rgba(129, 128, 128, 0.15)",

    },
    AnalyticsResult: {
        fontSize: 20,
        fontWeight: 700,
    },
    SuccessAnalytic:{
        float:"right",
        backgroundColor:"rgba(255, 255, 255, 0.47)",
        borderRadius: 5,
        color: "#5eb94b",

    },
    FlatAnalytic:{
        backgroundColor:"rgba(233, 233, 233, 0.47)",
        padding:"2px 8px",
        borderRadius: 5,
        float:"right"
    },
    ErrorAnalytic:{
        backgroundColor:"rgba(255, 255, 255, 0.47)",
        color: "#ab2a2a",
        padding:"2px 8px",
        borderRadius: 5,
        float:"right"
    },
    ErrorAnalyticLive:{
        backgroundColor:"#ab2a2a",
        color: "#ab2a2a",
        padding:"2px 8px",
        borderRadius: "50%",
    },
    styledImg: {
        height: 430,
        display: 'inline-block',
        [theme.breakpoints.up('lg')]: {
            paddingRight: 40,
        },
        [theme.breakpoints.up('xl')]: {
            height: 'auto',
        },
    },
    authStaticBg:{
      backgroundColor:theme.palette.secondary.main,
        display:'flex',
        justifyContent:'flex-start',
        alignItems:"center",
        flexDirection:"column",
        "& img.lamp":{
            width:120,
            marginBottom:100
        },
        "& img.logo":{
          width:"60%"
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    authContentImages:{
        display:'flex',
        justifyContent:'flex-start',
        alignItems:"center",
        flexDirection:'column',
        position:"absolute",
        top:0,
        left:"50%",
        transform:'translateX(-50%)',
        "& img.lamp":{
            width:40,
            marginBottom:20
        },
        "& img.logo":{
            width:"40%"
        },
    },
    authContainer:{
      height:"100vh",
        backgroundImage: `url(${AuthBg})`
    },
    authContent:{
        display:'flex',
        alignItems:"center",
        justifyContent:"center",
        [theme.breakpoints.down('md')]: {
            backgroundColor:theme.palette.secondary.main,
        },
    },
    authContentInner:{
        maxWidth:500,
        position:"absolute",
        top:"50%",
        left:"50%",
        transform:"translate(-50%,-50%) !important",
        "& h1":{
            width: "100%",
            textAlign: "center",
            fontSize: 17,
            margin: "5px 0"
        },
        "& .MuiCardHeader-root":{
            alignItems:'center !important'
        },
        "& .MuiPaper-rounded":{
            boxShadow: "0px 3px 30px 1px #0000001C",
            borderRadius:"30px !important"
        },
        [theme.breakpoints.down('md')]: {
            minWidth:"70vw",
            position:"absolute",
            top:"50%",
            transform:"translate(-50%,-50%) !important",
        },
        [theme.breakpoints.down('sm')]: {
            minWidth:"90vw",
            top:"40%",
            transform:"translate(-50%,-40%) !important",
        },
    },
    checkContentInner:{
        minWidth:400,
        [theme.breakpoints.down('sm')]: {
            minWidth:"90vw",
        },
    },
    textField: {
        width: '100%',
    },
    containerFull: {
        backgroundColor:"#f9f9f9"

    },
    loginContainerText: {
        alignContent: "center"
    },
    loginContainerForm:{
        textAlign: 'center',
        overflow: 'hidden',
        position:'relative',
        minHeight:600,
        zIndex: 0,
        paddingTop:20,
        paddingBottom:20
    },
    headLine: {
        fontWeight:"700 !important",
        fontSize:'20px !important',
        marginBottom: '20px !important',
        color:"#fff",
        textAlign:"center"
    },
    subLine: {
        fontSize:'17px !important',
        margin: '0 25px !important',
        textAlign:"center",
        color:"#e7e7e7",
    },
    socialLogin: {
        maxWidth: 27,
    },
    pointer: {
        cursor: 'pointer',
    },
    notiBtn: {
        justifyContent: 'flex-start',
        width: '100%',
        height: 56,
        fontSize: 18,
        borderRadius: 0,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        color: "#fefefe",
        [theme.breakpoints.up('sm')]: {
            height: 70,
        },
        [theme.breakpoints.up('md')]: {
            justifyContent: 'center',
            width: 'auto',
            color: theme.palette.grey[400],
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
        },
        [theme.breakpoints.up('xl')]: {
            paddingLeft: '2.5rem',
            paddingRight: '2.5rem',
        },
    },

    walletBtn:{
        borderRadius:0,
        justifyContent: 'flex-start',
        width: '100%',
        height: 56,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-end',

        },
        [theme.breakpoints.up('sm')]: {
            height: 70,
        },
    },
    NotifcationText:{
        color: "#2f2f2f",
        fontWeight:700,
        fontSize:12,
        marginBottom:0,
        textAlign:'right',
        direction:"ltr"
    },

    loginContainerFormBrd:{
        borderLeft:"1px solid #ddd !important",
        [theme.breakpoints.down('md')]: {
            borderLeft:"none !important",
        }
    },
    primaryColor:{
        color:theme.palette.primary.main
    },
    dateTable:{
        fontSize:"12px !important",
    },
    condir:{
    },
    thumbnail_code:{
        fontSize: "12px !important",
        textAlign: "center",
        marginTop: "5px !important",
        color: theme.palette.text.secondary
    },
    avatar_badge:{
        backgroundColor: theme.palette.primary.main,
        color: "#fefefe",
    },
    addImageBtn:{
        width: "100%",

        padding:"20px !important",
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center",
        borderColor:'rgba(0, 0, 0, 0.27) !important',
        '& .MuiButton-startIcon': {
            margin:"0 !important",
            '& .MuiSvgIcon-root': {
                fontSize:40,
                margin:"0 0 10px !important",
            },
        },
    },
    uploaderHolder:{
        width:200,
        marginRight:10,
        maxWidth:"calc( 50% - 5px)"
    },
    thumbnailWithPreview:{
        position:"relative",
        '& .MuiSvgIcon-root': {
            position:"absolute",
            top:"50%",
            left:10,
            transform:'translateY(-50%)'
        },
    },
    thumbnailWithPreviewChooser:{
        position:"relative",
        aspectRatio: "4 / 3",
        minHeight:115,
        backgroundColor:"#dbd8f3",
        borderRadius:5,
        width:"100%",
        '& .MuiSvgIcon-root': {
            position:"absolute",
            top:"50%",
            left:"50%",
            transform:'translate(-50%,-50%)'
        },
    },
    galleryItemHolder:{
        display:"block"
    },
    alertText:{
    },
    privacy_policy:{
        fontSize: "12px !important",
        marginBottom: "10px !important",
        marginTop: "10px !important",
    },
    mapMarker:{
        position:"absolute",
        top:-20,
        left:-40,
        backgroundColor:"#fff",
        borderColor:"#fff",
        whiteSpace:"nowrap",
        '&:after': {
            content: '""',
            width: 0,
            height: 0,
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderTop: "10px solid #fff",
            position: "absolute",
            bottom: -10,
        },
        '&:hover': {
            backgroundColor:"#fff",
            borderColor:"#fff",
        }
    },
    confirmationButtonButton:{
        marginRight:5,
        marginLeft:5,
        '& .MuiButton-label':{
            justifyContent:"space-between !important"
        }
    },
    currencyTextField:{

        '& input':{
            textAlign:"left"
        }
    },
    singleImageHolder:{
        position:"relative",
        border: "1px solid #ddd",
        borderRadius:12,
        '& button': {
            position: "absolute",
            bottom: 0,
            width: '100%',
            backgroundColor: "#333 !important",
            left:0,
            right:0,
        },
        '& img': {
            borderRadius:12,
        }
    },
    ratingContainer:{
        display:'inline',
        '& .MuiRating-root': {
        }
    },
    equalHolder:{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        flexWrap:"wrap"
    },
    voucher_text:{
        fontSize:12,
        display:"flex",
        alignItems:"center",
    },
    voucherList:{
        borderRadius:4,
        border: "1px solid"
    },
    program_card:{
        visibility:"visible",
        display:"flex",
        position:"relative",
        "& .MuiCardMedia-root":{
            aspectRatio:"4 / 3",
            width:"30%",

        },
        "& .MuiCardHeader-title":{
            fontSize:"14px !important",
            marginRight:35
        },
        "& .MuiCardHeader-subheader":{
            fontSize:"11px !important",
            marginTop:"10px !important",
        },
        "& .MuiCardHeader-root":{
           alignItems:"flex-start",
            width:"70%",
        },
        "& .MuiButtonBase-root":{
            position: "absolute",
            top: 0,
            right: 0,
        },

    },
    scheduled_item:{
        visibility:"visible",
        display:"flex",
        position:"relative",
        padding:10,
        "& .MuiCardMedia-root":{
            width:100,
        },
        "& .MuiCardHeader-title":{
            fontSize:"14px !important",
            marginRight:35
        },
        "& .MuiCardHeader-subheader":{
            fontSize:"11px !important",
            marginTop:"10px !important",
        },
        "& .MuiCardHeader-root":{
           alignItems:"flex-start",
            width:"70%",
        },
        "& .MuiButtonBase-root":{
            position: "absolute",
            top: 0,
            right: 0,
        },"& .schedule_status":{
            position: "absolute",
            top: 0,
            right: 0,
            color:"#fff",
            padding:"3px 10px",
            borderRadius:" 0  0 0 6px",
            fontSize:13,
        },

    },
    channel_card:{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        backgroundColor:"transparent",
        border:"1px solid #2B2B2B",
        height:"100%",
        "& img":{
            width:125,
            margin:10,
            borderRadius:8
        },
        "& .MuiCardContent-root":{
            padding:"10px !important"
        },
        "& .MuiTypography-body1":{
            fontSize:12,
            marginBottom:10,
            opacity:0.75
        },
    },
    program_card_front:{
        background:"transparent",
        transition:'0.3s all ease',
        display:"block",
        cursor:'pointer',
        "& .overlay":{
            transition:'0.3s all ease',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,105,88,.6)",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            opacity:0,
            visibility:"hidden",
            "& svg":{
                fontSize:75
            }
        },
        "& p":{
            cursor:'pointer',
        },
        "&:hover ":{
            "& img":{
                transform:"scale(1.05)"
            },
            "& .overlay":{
                opacity:1,
                visibility:"visible",
            }
        },
        "& img":{
            transition:'0.3s all ease',
           aspectRatio:1.5,
            width:'100%',
            borderRadius:4,
        },
    },
    program_card_front_2:{
        background:"transparent",
        marginBottom:10,
        display:'flex',
        alignItems:"center",
        "& .MuiCardMedia-root":{
           aspectRatio:4/2.4,
            width:"30%",
            borderRadius:6,
        },
        "& .MuiCardContent-root":{
            width:'70%'
        },
        "& h3":{
            fontSize:15,
            margin:0,
            marginBottom:7
        },
        "& p":{
            fontSize:12,
            opacity:.6
        },

    },
    program_card_front_search:{
        display:'flex',
        alignItems:"center",
        "& .MuiCardMedia-root":{
           aspectRatio:4/2.4,
            width:70,
            borderRadius:6
        },
    },
    titleHolder:{
        padding: "0 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems:"center",
        opacity: 1,
        visibility: "visible",
        background: theme.palette.background.paper,
        width:"100%",
        [theme.breakpoints.down('sm')]: {
            left:0
        },
    },
    titleHolderPrograms:{
        padding: "0 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems:"center",
        opacity: 1,
        visibility: "visible",
        background: theme.palette.background.paper,
        width:"100%",
        marginBottom:20,
        position:'fixed',
        zIndex:99,
        left:0,
        top:57,
        [theme.breakpoints.down('sm')]: {
            top:70
        },
    },
    finalTimeShower:{
        background: "#0d443b",
        visibility: "visible",
        display: "flex",
        borderRadius:3,
        justifyContent: "space-between",
        alignItems:"center",
        padding: "6px 24px",
        "& .time_holder":{
            "& p":{
                margin:0
            },
            "& h3":{
                margin:0,
                fontSize:"30px !important"
            }
        },
        "& .time_holder.error":{
            color: "red",
        },
    },
    homeChannelsSection:{
        background: "#111111",
        padding:"25px 0"
    },
    contentHolder:{
        minHeight:460
    },
    HomeContainerPrograms:{
        paddingRight:0
    },
    programScheduleButton:{
        borderWidth:"2px !important",
        "& .MuiButton-label":{
            display:"flex",
            flexDirection:"column",
            width:50,
            color:"#fff",
            [theme.breakpoints.down('sm')]: {
                width:35,
                fontSize:12
            },
        },
    },
    scheduleItems:{
        display:"flex",
        flexDirection:"column",
    },
    scheduleItem:{
        position:"relative",
      display:'flex',
      alignItems:"center",
      justifyContent:"center",
        borderRadius:8,
        margin:"10px 0",
        '& .thumbnail':{
          marginRight:35,
            aspectRatio: 4 / 3,
            marginLeft:5,
            [theme.breakpoints.down('sm')]: {
                marginRight:15,
            },
        },
      '& img':{
          width:165,
          borderRadius:8,
          marginTop:5,
          [theme.breakpoints.down('sm')]: {
              width:65,
              borderRadius:4,
          },
      },
      '& .info':{
          width: "calc(50% - 300px)",
          marginRight:60,
          "& h2":{
              fontSize:15,
              [theme.breakpoints.down('sm')]: {
                  fontSize:12,
              },
          },
          [theme.breakpoints.down('sm')]: {
              width:"100%",
              marginRight:10,
          },
      },
      '& .times':{
          display:'flex',
          alignItems:"center",
          justifyContent:"center",
          width:"50%",
          '& .single-time':{
              display:'flex',
              flexDirection:"column",
              alignItems:"center",
              justifyContent:"center",
              width:"25%",
              '& time':{
                  marginTop:5
              }
          }
      },
        '&:after':{
            content: '" "',
            borderBottom: "3px solid #2C2C2C",
            display:"block",
            width:"100%",
            position:"absolute",
            bottom:-10,
        },
    },
    searchDrawer:{
        "& .MuiDrawer-paper":{
            padding:20,
            borderBottom:"2px solid #2dceb3"
        }
    },
    notFoundClass:{
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        flexDirection:"column",
        minHeight:300,
        opacity:.7,
        fontSize:20,
        "& svg": {
            fontSize:50,
            marginBottom:20,
            opacity:.7,
        }
    },
    mainSearch:{
        boxShadow: "0px 0px 3px 0px rgba(255,255,255,.4) !important"
    },
    single_comment:{
        background:"#111111",
        marginBottom:10,
        borderRadius:6,
    },
    submit_comment_holder:{
        background:"#111111",
        marginBottom:10,
        borderRadius:6,
        marginRight:0,
        marginLeft:0,
        width:"100%"
    },
    single_comment_date:{
        position: "absolute",
        right: 17,
        top: 26,
        fontSize: 12,
    },
    profileCard:{
        display:"flex",
        alignItems:"center",
        justifyContent:"flex-start",
        "& .MuiAvatar-circular":{
            width:50,
            height:50
        },
        "& .name_holder":{
            marginLeft:10,
            "& p":{
                cursor:"pointer",
            },
            "& .username":{
                fontSize:11,
                textAlign:"left",
                marginTop:4,
                opacity:0.7
            }
        },

    },
    profileUser:{
        backgroundColor:"#424242",
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        padding:15,
        marginTop:20,
        marginBottom:20,
        borderRadius:6,
        [theme.breakpoints.down('md')]: {
            flexDirection:"column"
        },
        "& .MuiAvatar-circular":{
            width:100,
            height:100,
            [theme.breakpoints.down('md')]: {
                width:70,
                height:70,
            },
        },
        "& .name_holder":{
                display:"flex",
            alignItems:"center",
            "& strong":{
                fontSize:17
            },
            "& .username":{
                marginLeft:10,
                opacity:0.7,
            },
            "& .content_info":{
                    marginLeft:15,
                "& .user_name":{
                    marginBottom:10
                }
            }
        },
        "& .profile_info":{
            display:"flex",
            "& span":{
                display:"flex",
                flexDirection:"column",
                alignItems:"center",
                marginRight:20,
                fontSize:12,
                "& strong":{
                    fontSize:20
                }
            },
            [theme.breakpoints.down('md')]: {
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 15,

},
        }
    },
    headerMenu:{
        minWidth:235,
        overflow:"hidden"
    },
    insideMenuHolder:{
        padding: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        justifyContent: "space-between",
        height: "100%",
    },
    actionHolder:{
        display:"flex",
        alignItems:"center",
        flexDirection:"row-reverse",
        "& .visits_count":{
            marginRight:10,
            marginLeft:15
        }
    },
    languageSwitcherItem:{
        "& img":{
            marginRight:7
        }
    },
    closeBtn:{
      position:"absolute",
      top:15,
      right:15
    },
    contactCard:{
        textAlign:'center',
        "& .MuiCard-root":{
            display: "flex",
            flexDirection: 'column',
            alignItems: 'center',
            padding: 20,
        },
        "& svg":{
            color:theme.palette.primary.main,
            fontSize:40,
            marginBottom:20
        },
    },
    message_sent:{
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px !important',
        margin:20,
        color:theme.palette.primary.main,
        border: "2px solid",
        borderColor: theme.palette.primary.main,
        borderRadius:4,
        "& svg":{
            fontSize:100,
            marginBottom:20
        },
        "& .MuiTypography-body1":{
            marginBottom:20
        },

    },
    dialogPriceCheck:{
        "& p":{
            display: "flex",
            alignItems: 'center',
            justifyContent:"space-between",
            marginBottom:25
        },
    },
    chanelChooserButton:{
        marginRight:10,
        marginBottom:10,
        minWidth: 180,
        display: 'flex',
        justifyContent: 'space-between',
        borderWidth:"2px !important",
        "& .MuiAvatar-root":{
            border: "1px solid #c6c6c6"
        },
        "&.active .MuiAvatar-root":{
            border: "1px solid #2DCEB3"
        },
        "&.active ":{
            backgroundColor:"rgba(45, 206, 179, 0.08)"
        }
    },
    program_card_live:{
        position:"absolute",
        left:10,
        top:10,
        background:theme.palette.primary.main,
        color:"#fff",
        borderRadius:6,
        padding:" 10px 15px",
        display:'flex',
        alignItems:'center',
        justifyContent:"space-between",
        "& img":{
            width: 50,
            borderRadius: 6,
            marginRight: 10,
        }

    },
    channelChooserFixed:{
        position: "fixed",
        marginTop: 15,
        left: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 10px",
        paddingRight: 20,
        background:" #0f0f0f",
        borderRadius: "0 0 8px 0",
        zIndex: "999",
        transition: "all 0.5s ease",
        "&.hide":{
            left: -210
        },
        "& .MuiIconButton-root":{
            position: "absolute",
            right: -30,
            top:0,
            background: "#0f0f0f",
            borderRadius:"0 8px 8px 0",
            padding: 6,
            color: "#999999",
            "&:hover":{
                background: "#0f0f0f",
            }
        }
    },
    adButton:{
        position:"absolute",
        bottom:40,
        left:20,
        backgroundColor:"rgba(255,255,255,0.1)"
    },
    adButtonDesc:{
        position:"absolute",
        bottom:40,
        right:20,
        backgroundColor:"rgba(255,255,255,0.1)"
    },
    addMatchBtn:{
        width:"100%",
        "& svg":{
            fontSize:"25px !important",
        },
        "& .txt":{
            color:"#333",
        },
        "& .MuiButton-endIcon":{
            position:'absolute',
            left:15,
        }
    },
    usermenu:{
        display:"flex",
        alignItems:'center',
    },
    LayoutLogo:{
        width:145,
        [theme.breakpoints.down('md')]: {
            width:120
        },
    },
    LayoutLogoMobile:{
        height:40,
    },
    notifHolder:{
        borderRadius:"0 !important",
        minHeight:64,
        margin:"0 10px !important",
        aspectRatio:1,
        [theme.breakpoints.down('md')]: {
            margin:"0 !important",
        },
    },
    menuWalletBtn:{

    },
    appLoader:{
        height:'100vh',
        margin:0,
        backgroundColor:"#fff",

    },
    layoutMain:{
        display:"flex",
        justifyContent:"space-between"
    },
    layoutHolder:{
        paddingTop:100,
        paddingBottom:50,
        width:"100%",

        [theme.breakpoints.down('md')]: {
            paddingTop:150,
        },
        "&.front-layout":{
            paddingTop:0,
            paddingBottom:0,
        },
        "&.panel-layout":{
            [theme.breakpoints.down('md')]: {
                paddingBottom:85,
                paddingTop:75,
            },
            [theme.breakpoints.up('md')]: {

                paddingLeft:20,
                paddingRight:40,

            },
        }
    },
    homeLayout:{
        paddingTop:100,
        [theme.breakpoints.down('md')]: {
            paddingTop:150,
        },
    },
    discoverLayout:{
        paddingTop:100,
        [theme.breakpoints.down('md')]: {
            paddingTop:120,
        },
        paddingBottom:100
    },
    vendorLayout:{
        paddingBottom:50,
    },
    productCardPanel:{
        borderRadius:"12px !important",
        position:"relative",
        boxShadow:" none !important",
        background: "#f9f9f9 !important",
        border: "1px solid #eee",
        "& .productCardMedia":{
            justifyContent:"center",
            display: "flex",
            alignItems:"center",
        },
        "& .productCardImage":{
            height:"auto",
            borderRadius:12,
            marginTop:20,
            width:"150px !important"
        },
        "& .shopBg":{
            position:"absolute",
            top:0,
            left:0,
            backgroundColor:"rgba(0,0,0,.5)",
            padding:"5px 10px",
            borderRadius: "12px 0",
            "& img":{
                background: "#fff",
                borderRadius: 50,
            }
        },
        "& .productInfo": {
            textAlign:"center",
        },
        "& .cardOptions":{
            display:"flex !important",
            alignItems:"center",
        },
        "& .avatarInProduct":{
           width:30,
            height:30,
        }
    },
    shopNameInCard:{
        color:"#fff",
        textDecoration:"none",
        marginLeft:5,
        fontSize:16,
    },
    priceInCard:{
        color:theme.palette.primary.main,
    },
    bottomNav:{
        borderBottomStyle:"solid",
        borderBottomColor:theme.palette.primary.main,
        borderBottomWidth:2,
        boxShadow:"0 -2px 6px rgba(0,0,0,.13)",
        position:"fixed",
        bottom:0,
        left:0,
        width:"100vw",
        zIndex:999,
        borderTopLeftRadius:30,
        borderTopRightRadius:30,
        "& .MuiBottomNavigationAction-root":{
            minWidth:60
        }

    },
    categoryHold:{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        marginBottom:10,
        "& .actions":{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        "& .details":{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        "& .children_holder":{
            marginTop:10
        },
    },
    footer: {
        borderTop: "1px solid #D9D9D9",
        borderBottomColor: theme.palette.primary.main,
        borderBottomStyle: "solid",
        borderBottomWidth: 4,
        padding: "40px 5px 40px 5px",
        [theme.breakpoints.down('md')]: {
            marginBottom:20,
        },
        "& .subheading":{
            fontWeight:700,
            marginBottom:10
        },
        "& .MuiTypography-root":{
            fontSize:14,
            lineHeight:1.8,
            maxWidth:"85%",
            textAlign:"justify",
            [theme.breakpoints.down('md')]: {
                maxWidth:"100%",
            },
        },
        "& .social-holder": {
            marginTop: 20,
            "& .MuiButtonBase-root": {
                width: 50,
                height: 50,
            }
        },
        "& ul li":{
            paddingLeft:0,
        },
        "& ul li a":{
            color: theme.palette.text.main,
            fontSize:14,
            textDecoration:"none",
            marginBottom:5,
        },
        "& .footer-app":{
            backgroundColor:"#fdeaec",
            borderRadius:16,
            display:"block",
            maxWidth:"80%",
            marginBottom:10,
            "&:hover":{
                backgroundColor:"#f8bcc2",
                transition:"all .3s"
            },
            [theme.breakpoints.down('md')]: {
                maxWidth:"100%",
            },
        },
    },
    categorySliderItem:{
        "& img":{
            maxWidth:"100%",
            borderRadius:"100%"
        }
    },
    bannerSliderItem:{
        textAlign:"center",
        "& img":{
            maxWidth:"100%",
            borderRadius:18
        }
    },
    vendorSliderItem:{
        position:"relative",
        borderRadius:25,
        boxShadow:"none !important",
        background:"none",
        transition:" all .4s ease-in",
        "&.not_in_radius":{
            filter: "grayscale(1)",
        },
        "&:hover .card-media":{
            filter: "drop-shadow(2px 4px 6px rgba(0, 0, 0, .6)) brightness(1)",
        },
        "&:hover .vendor-title":{
            color:theme.palette.primary.main,
        },
        "& .card-media":{
            height:180,
            position:"relative",
            borderRadius:16,
            [theme.breakpoints.down('md')]: {
                height:170,
            },
        },
        "& .card-content":{
            padding:"12px 0 0 0 !important",
            position:"relative",
        },
        "& .chips-holder":{
            position:"absolute",
            top:6,
            left:6,
            display:'flex',
            alignItems:"flex-start",
            gap:5,
            flexDirection:"column",
            "& .MuiChip-root":{
                height:28
            }
        },
        "& img":{
            maxWidth:"100%",
            borderRadius:"100%"
        },
        "& .logo":{
            position:"absolute",
            bottom:"-15px",
            left:14,
            width:50,
            background: "#fff",
            padding: 5,
            boxShadow: "0 2px 10px rgba(0, 0, 0, .2)",
            aspectRatio:1,
        },
        "& .vendor-title":{
            fontWeight:700,
            fontSize:18,
            color: theme.palette.text.primary,
            textDecoration:"none !important",
            marginBottom:2,
            marginTop:3,
            display:"block",
        },
        "& .infobar":{
            display:"flex",
            alignItems:"center",
            justifyContent:"flex-start",
            "& .category:hover a": {
                color: theme.palette.secondary.main,
                transition:"all .2s"
            },
            "& span":{
                display:"flex",
                alignItems:"center",
                marginRight:14,
                fontSize:13,
                whiteSpace:"nowrap",
                "&.free":{
                    color:theme.palette.primary.main,
                    "& svg":{
                        color:theme.palette.primary.main,
                    },
                },
            },
            "& .lucide-small":{
                marginRight:6,
            },
        },
        "& .wish-holder":{
            position:'absolute',
            right:0,
            top:0
        }

    },

    SingleCardProduct:{
        position:"relative",
        display:"flex",
        boxShadow:"none !important",
        border:"1px solid #eee",
        borderRadius:"16px !important",
        padding:"15px 5px 15px 15px",
        "&:hover":{
            borderColor: theme.palette.primary.main,
            transition:"all .3s ease"
        },
        "& .media-holder":{
            aspectRatio:1,
            width:"25%",
            position:"relative",
            "& img":{
                borderRadius:"16px !important",
                border: "1px solid #eee",

            },
        },
        "& .card-content":{
            paddingBottom: "0 !important",
            padding:"0 5px 0 10px",
            "& .product-title":{
                lineHeight:"1.4 !important"
            }
        },
        "& .card-content.media-wide":{
            display:"flex",
            justifyContent:"space-between",
            flexDirection:"column"
        },
        "& .discount_percent":{
            position:"absolute",
            top:"-10px",
            left:"50%",
            background: theme.palette.primary.main,
            padding: "4px 15px",
            borderRadius: 8,
            transform: "translateX(-50%)",
            color:" #fff",
            fontSize: 17,
            fontWeight: 700,
            [theme.breakpoints.down('md')]: {
                fontSize: 14,
            },
        },
        "& .rating-holder":{
            top:4,
            right:12,
        },
        "& .product-card-info.vendor:hover":{
            color:theme.palette.primary.main
        },
        "& img":{
            maxWidth:"100%",
        },
        "& .prd-card-footer":{
            display:"flex",
            alignItems:"center",
            justifyContent:"space-between",
        },
        "& .pricing":{
            display:"flex",
            alignItems:"center",
            justifyContent:"space-between",
            width:" 100%",
            "& strong":{
                fontSize: "17px !important",
            },
        },
        "&.clickable":{
            cursor:'pointer',
            transition:"0.5s ease all",
            "& .media-holder":{
                width:"25%",
                [theme.breakpoints.down('md')]: {
                    width:"16%",
                },
                [theme.breakpoints.down('sm')]: {
                    width:"25%",
                },
            },
            "& .card-content":{
                paddingLeft:20,
            },
            "& .pricing":{
                justifyContent:"flex-start !important",
                position: "absolute",
                bottom: 20,
                [theme.breakpoints.down('md')]: {
                    bottom: 8,
                },
            },
            "& .product-desc":{
                fontSize:"13px !important",
                color: "#666",
                lineHeight: "1.2",

            },
            "& .rating-holder":{
                top:8,
                right:10
            },
            "& .addToCart":{
                backgroundColor:theme.palette.secondary.main,
                borderRadius:100,
                position:"absolute",
                bottom:10,
                right:10,
                transition:".5s ease all",
                "&.disabled":{
                    color: "rgba(0, 0, 0, 0.26)",
                    boxShadow: "none",
                    backgroundColor: "rgba(0, 0, 0, 0.12)",
                    transform:"scale(1) !important",
                    cursor:"default"
                },
                "&:hover":{
                    transform:"scale(1.05)"
                },"&.more-quantity":{
                    backgroundColor:"transparent",
                    border:"1px solid",
                    borderColor:theme.palette.secondary.main,
                    color:theme.palette.secondary.main,
                    "& .Mui-disabled svg":{
                        color: "rgba(0, 0, 0, 0.26)",
                    },
                    "& svg":{
                        color:theme.palette.secondary.main,
                        width:20,
                        height:20,
                        strokeWidth: 1.5,
                        "&.trash":{
                            width:17,
                            height:17,
                        },
                    },
                },
                "& svg":{
                    color:"#fff",
                    width:26,
                    height:26,
                    strokeWidth: 1.8,
                },
            },

        }
    },
    vendorMenuContainer:{
      position:"sticky",
        top:87,
        zIndex:999,
    },
    vendorMenuHolder: {
        backgroundColor: "#fff",
        boxShadow: " 0 2px 10px rgba(0,0,0,.2)",
        padding: 10,
        borderRadius: 16,
        marginTop:"-32px",
        [theme.breakpoints.down('md')]: {
            padding: "10px 10px",
        },
       "& .container":{
            display: "flex",
            alignItems: "center",
            justifyContent: 'space-between',
        },
        "& .swiper-slide":{
                width:"auto !important"
        },
        "& .menu-name":{
            fontSize:"14px !important"
        },

    },

    vendorHeader:{
        background: `url(${VendorBg}) , linear-gradient(90deg, #a90113 0%, #ff6778 100%)`,
        paddingTop:100,
        paddingBottom:60,
        [theme.breakpoints.down('md')]: {
            paddingTop:105,
        },
        "& .actions":{
            [theme.breakpoints.down('md')]: {
                display:"flex",
                alignItems:"center",
                justifyContent:"flex-start",
                gap:7,
            },
            "& .info-buttons-vendor":{
                [theme.breakpoints.down('md')]: {
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"flex-end",
                    gap:7,
                    marginTop:0,
                },
            },
        },
        "& .vendor-breadcrumb":{
            position: "absolute",
            top: 58,
            left: 0,
            padding: 10,
            width:"100%",
            "& nav li":{
                color:"#fff",
                "& a ,& strong":{
                    color:"#fff"
                }
            },
            [theme.breakpoints.down('md')]: {
                padding:"2px 10px"
            },
        },
        "& .chips-holder":{
            display:"flex",
            gap:10
        },
        "& .rating-vendor":{
            position:"unset",
            background:" #ffffff",
            padding:" 2px 10px",
            borderRadius: 50,
            marginLeft:10,
            [theme.breakpoints.down('md')]: {
                marginLeft:0,
                marginTop:10,
                display:"inline-flex",
                fontSize:14,
                padding: "2px 6px 2px 4px",
            },
        },
        "& .header-sec":{
            "& .mobileRate":{
                [theme.breakpoints.down('md')]: {
                    marginRight:15,
                    display:"flex",
                    alignItems:"center",
                    flexDirection:"column",
                    "& .rating-holder":{
                        marginTop:-5
                    },
                },
            },
            "& .logo":{
                minWidth:140,
                maxWidth:140,
                borderRadius:"100%",
                padding:5,
                marginRight:30,
                background:"#fff",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                aspectRatio:1,
                [theme.breakpoints.down('md')]: {
                    marginRight:0,
                    minWidth:100,
                    maxWidth:100,
                },
                "& img":{
                    maxWidth:"100%",
                    borderRadius:"100%",
                }
            },
            "& .vendor-name":{
                color:"#fff",
                marginBottom:"0 !important",
                marginRight:10
            },
            "& .details":{
                marginTop: 10,
                marginBottom: 10,
                "& span.details-text":{
                    color:"#fff",
                    fontSize:14,
                    marginRight:30,
                },
                "& .category-holder":{
                    color:"#fff",
                    fontSize:14,
                    marginRight:30,
                    "& a":{
                        color:"#fff",

                    },
                },
            },
            "& .informations":{
                width:"100%",
                "& .title-star-chip": {
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"flex-start",
                    marginBottom:10,
                    [theme.breakpoints.down('md')]: {
                       flexDirection:"column",
                        justifyContent:"flex-start",
                        alignItems:"flex-start",
                    },
                },
            },
            "& .description":{
                fontSize:"15px !important",
                color:"#eee"
            },

            "& .infos":{
                display:'flex',
                alignItems:'center',
                width:"100%",
                "& .informations":{
                    "& .bellow-title":{
                        display:"flex",
                        alignItems:'center',
                        justifyContent:"flex-start",
                        overflow:'hidden',
                    }
                }
            }
        }
    },
    productDialog:{
        "& img.slider-img":{
            width:"100%",
            aspectRatio:1,
            borderRadius:16,
        }
    },
    panelAppBar:{
        borderRadius:  12,
        padding:15,
        boxShadow:'none !important',
        backgroundColor:"#fdf4f5 !important",
        marginBottom:20,
    },
    panelAppBarOnlyOne:{
        boxShadow:'none !important',
    },
    cartWidget:{
        position: "sticky",
        top: 200,
        marginTop:50,
        backgroundColor:"#fff",
        borderTop: "3px solid #F0051F !important",
        boxShadow: "0 0 15px rgba(0, 0, 0, .1) !important",
        borderRadius:"0 0 16px 16px !important",
        "& .heading":{
            fontSize:"20px !important"
        }
    },
    cartProductsContainer:{
      overflowY:"auto",
    },
    cartProduct:{
      display:"flex",
        padding:10,
        marginBottom:10,
        gap:10,
        backgroundColor:"rgba(255,53,75,0.05)",
        borderRadius:12,
        "& .img-holder img":{
          width:60,
            borderRadius:12
        },
        "& .content-holder ":{
          width:"100%",
            display:"flex",
            flexDirection:"column",
            justifyContent:'space-between',
          "& .actions":{
              display:"flex",
              alignItems:"center",
              justifyContent:'space-between'
          }

        }
    },
    cartWidgetActions:{
        boxShadow:"0 -3px 10px rgba(0,0,0,.2)",
        padding:"20px 15px !important",
        "& p":{
            display:"flex",
            alignItems:"center",
            justifyContent:"space-between",
        },
        "& .confirm-btn":{
            width:"100%"
        }
    },
    contactCta:{
        backgroundImage: `url(${ContactBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100%",
        borderRadius: 16,
        "& .overlay":{
            width: "100%",
            height: "100%",
            backgroundColor:" rgba(0,0,0,.5)",
            borderRadius: 16,
            padding: 30,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            "& p":{
                fontSize: "16px !important",
                lineHeight: "30px !important",
                color: "#fff",
                margin: "20px 0 40px 0",
            },
        },

    },
    nothingFoundComponent:{
        borderRadius:12,
        padding:"60px 20px",
        textAlign:"center",
        backgroundColor:"#f5f5f5",
        "& .icon-holder svg":{
            width:60,
            height:60,
            color:theme.palette.primary.main,
        },
        "& .heading":{
            fontSize:"16px !important",
            color:"#666666",
            marginBottom:"0 !important",
        },
        "& p":{
            marginTop:10,
            marginBottom:30,
            color:"#666666",
        },
    },
    singleOrderItem:{
        position:"relative",
        borderRadius:16,
        border: "1px solid #ebebeb",
        backgroundColor:"#f9f9f9",
        padding:"20px 13px 13px 13px",
        "&.finished, &.canceled":{
            filter: "saturate(0.8)",
            background:" #ebebeb",
        },
        "& img.logo":{
            maxWidth:60,
            borderRadius:100
        },
        "& .positon-top": {
            position: "absolute",
            top: 10,
            right: 10,
            "& .charity-icon":{
                backgroundColor:theme.palette.primary.main,
                color:"#fff",
                marginLeft:5,
                cursor:"default"
            }
        },
        "& .shopName":{
            fontSize:15,
            fontWeight:600,
        },
        "& .time":{
            fontSize: "13px !important",
            margin:" 2px 0",
        },
        "& .bg-gray":{
            backgroundColor:"#f1f1f1",
            borderRadius:100,
            padding: "0 5px 5px 5px",
            margin:"15px 0 20px 0",
            minHeight:75,
        },
        "& .badge-order-item":{
            "& .MuiBadge-badge":{
                backgroundColor:"#f1e2e2",
                color: theme.palette.primary.main,
                borderRadius:4,
                right:10,
            }
        },
        "& .price-holder":{
            fontSize:15,
            fontWeight:700
        },
        "& .product-small-img img":{
            width:45,
            borderRadius:10,
            marginRight:10,
            aspectRatio:1,
        },
        "& .items-holder":{
            display:"flex",
            alignItems:"center",
            justifyContent:"space-between",
            margin:"10px 0 ",
            "& .products-holder":{
                display:"flex",
                alignItems:"center",
                gap:5
            }
        },
    },
    orderStatus:{
        padding: "5px 15px",
        borderRadius: 100,
        display:"inline-block",
    },
    checkoutItem:{
        "& .MuiBox-root":{
            background:"#f9f9f9",
            borderRadius:12,
            padding:20,
            "& .subheading":{
                marginBottom: 10,
                fontWeight: 700,
            },
            "& .delivery-wide":{
                display:"flex",
                alignItems:"center",
                justifyContent:"space-between",
            },
            "& .flex-direction":{
                "& .time":{
                    backgroundColor:"#eeffe5",
                    borderRadius:50,
                    padding:"5px 15px",
                    fontSize:"13px !important",
                    fontWeight:700,
                    border:"1px solid",
                    borderColor: theme.palette.secondary.main,
                    color:theme.palette.secondary.main,
                }
            },
            "& .paymentItem":{
                padding: 12,
                border:" 1px solid #ddd",
                borderRadius: 12,
                minHeight: 64,
                marginBottom: 10,
                "&.off":{
                    opacity:0.4
                }
            },
        },
    },
    checkoutItems:{
        "& .checkoutItemsDetails":{
            padding: "10px 10px 5px 10px",
            borderRadius: 12,
            marginBottom: 10,
            backgroundColor: "rgba(255, 53, 75, 0.05)",
            "& img":{
                maxWidth:60,
                borderRadius:4
            }
        },
    },
    cartRemoveItem:{
        fontSize: "13px !important",
        "& .MuiButton-startIcon":{
            marginRight:5,
        },
    },
    buttonAlert:{
        backgroundColor:"#ff8900 !important",
        boxShadow:"0 2px 8px rgba(0,0,0,0.3) !important",
    },
    cardHelp:{
        borderLeft:"3px dotted #ddd",

        padding:15,
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        alignItems:'center'
    },
    alertBox:{
        "&.list":{
            maxHeight: 250,
            overflowY:"auto",
            border: "1px solid #ddd",
            padding: 15,
            borderRadius: 16,
        },
        "& .MuiAlert-root":{
            padding: "5px 10px",
        },
        "& .alert-time":{
            fontSize:13,
            color:"#444",
            paddingTop: 5,
            display: "block",
        },
        "& .MuiAlert-icon":{
            marginRight: 0,
            [theme.breakpoints.down('md')]: {
                display:"none",
            },
        },

    },
    flagStyle:{
        width: 20,
        height: 20,
        marginRight: theme.direction === "rtl" ?  0 : 5,
        marginLeft: theme.direction === "rtl" ?   5 : 0,
        borderRadius: 6
    }
};
